// @ts-nocheck

const MEMBERSHIP_PRODUCT_ID = 10556040479004;
const HARDWARE_VARIANT_ID = 52555030528284;

document.addEventListener('rebuy:cart.change', () => {
  // Skip if product-form.js is mid-swap — the membership is being replaced and
  // will be re-added momentarily. Acting here would remove hardware incorrectly.
  if (window.__membershipSwapInProgress) return;

  setTimeout(async () => {
    if (window.__membershipSwapInProgress) return;

    const cart = await fetch('/cart.js').then((r) => r.json());
    const hasMembership = cart.items.some((item) => item.product_id === MEMBERSHIP_PRODUCT_ID);
    const hardwareItem = cart.items.find((item) => item.variant_id === HARDWARE_VARIANT_ID);

    if (!hasMembership && hardwareItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: hardwareItem.key, quantity: 0 }),
      });

      // Prompt Rebuy to re-read the cart since we changed it via Shopify's API directly.
      if (window.Rebuy?.Cart?.load) {
        window.Rebuy.Cart.load();
      }
    }
  }, 300);
});
